module.exports = __webpack_public_path__ + "static/media/rating-star-full.eaa4e6c4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/trailways/rating-star-full.svg
// module id = 939
// module chunks = 0